module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_litigation-mediation-and-arbitration.35d50a64.png";